import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { documentStatusReportQueryOptions } from '~bank-reports/service/documentStatusReportQueryOptions'

import { DocumentStatusResponse } from '../types'
import { DocumentStatusReportContext } from './reportContext'

export const DocumentStatusReportContextProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const routeApi = getRouteApi('/_app/reports/document-status')
  const search = routeApi.useSearch()

  const { data, isFetching } = useQuery<DocumentStatusResponse>(documentStatusReportQueryOptions(search))

  if (!data) return null

  return (
    <DocumentStatusReportContext.Provider value={{ data, isFetching, routeApi }}>
      {children}
    </DocumentStatusReportContext.Provider>
  )
}
